"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itCompanyNumberChecker = void 0;
var PARTITA_IVA_REGEX = /^\d{11}$/;
var itCompanyNumberChecker = exports.itCompanyNumberChecker = function itCompanyNumberChecker(companyNumber) {
  return PARTITA_IVA_REGEX.test(companyNumber);
};